import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";

export default function useReduxAction(run: (dispatch: Dispatch) => any, dependencies: React.DependencyList) {
    const dispatch = useDispatch();

    useEffect(() => {
        run(dispatch);
    }, dependencies)
}